module.exports = __webpack_public_path__ + "img/mortgage-loan.184cd363.png";